<template>
  <div v-if="!item.zoom_img" class="w-full h-full flex align-items-center justify-content-center">
    <img
      class="object-contain w-full h-auto"
      :src="`/media/${item.img}.webp`"
      :alt="item.img"
    />
  </div>
  <Image
    v-else
    alt="Image"
    preview
    class="w-full h-full flex align-items-center justify-content-center"
  >
    <template #image>
      <img
        class="object-contain w-full h-auto"
        :src="`/media/${item.img}.webp`"
        :alt="item.img"
      />
    </template>
    <template #preview="slotProps">
      <img
        :class="slotProps.class"
        :src="`/media/${item.img}.webp`"
        alt="preview"
        :style="slotProps.style"
        @click="slotProps.onClick"
      />
    </template>
  </Image>
</template>
<script setup>
const props = defineProps({
  item: Object,
})
</script>
